import React from "react";
import Query from "react-apollo/Query";
//import { Mutation } from "react-apollo";
import { GET_PAYPAL_REQUEST } from "../../../queries";

class OfferPayPalHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reload: false       
        };
    }

    /*deleteOfferEvent = (event, deleteOffer) => {
        event.preventDefault();        
        let newReload = this.state.reload; 
        deleteOffer().then(({ data }) => {
            window.open(`https://launch.artyfact.game/withdrawal`, '_top');
            //this.setState({reload: !newReload});
            //console.log(this.state.reload);
        })
    };*/

    render() {
        let self = this;
        return (
            <div className="MarketPageWithdrawalMoneyIn MarketPageWithdrawalMoneyIn02">
                <div class="ReferalStatisticPageTitle mt10px">PayPal history</div>
                <div className="row width98p">
                    <div className="col-md-12">
                        <div className="CertTable mt10px">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Amount $</th>
                                        <th>ARNO</th>
                                        <th>Name Package</th>
                                        <th>Cashback</th>
                                        <th>Status</th>
                                        <th>Time</th>
                                        <th>Detailed info</th>
                                    </tr>
                                </thead>
                                <tbody>
                                
                                <Query query={GET_PAYPAL_REQUEST} variables={{ email: this.props.session.email }}>
                                    {({ data, loading, error}) => {
                                        if (loading) return <div>loading</div>;
                                        if (error) return <div>error</div>;
                                        let self = this;
                                        
                                        let AllPayPalRequests = data.getPayPalRequest.map(function My(Request) {
                                            if (Request) {
                                                let cashback = 0;
                                                if (Request.value < 200) { cashback = Request.arno * 0.01 }
                                                if (Request.value >= 200 && Request.value < 400) { cashback = Request.arno * 0.03 }
                                                if (Request.value >= 400) { cashback = Request.arno * 0.05 }
                                                return (
                                                    <tr>
                                                        <td>{Request.value} $</td>
                                                        <td>{Request.arno}</td>
                                                        <td>{Request.item_name}</td>
                                                        <td>{cashback.toFixed(2)}</td>
                                                        <td>{Request.status}</td>
                                                        <td>{Request.create_time}</td>                                                        
                                                        <td><a href={Request.pay_link} target="_blank">Info</a></td>
                                                    </tr>
                                                )
                                            }
                                        });

                                        return AllPayPalRequests                                                            
                                        
                                    }
                                }
                                </Query> 
                                
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default OfferPayPalHistory